module.exports = __webpack_public_path__ + "media/application/images/svgs/linkedin-55e3b9000b8a1d9313525ce786f498df.svg";